import React, {useMemo} from 'react';
import {Dropdown, DropdownAlign, DropdownOrderBy, DropdownRequiredType, SelectListItem} from '@renta-apps/athenaeum-react-components';
import TransformProvider from '@/providers/TransformProvider';

interface TimeDropdownProps {
    id: string;
    label: string;
    disabled?: boolean;
    selectedTime?: string;
    onTimeChange: (time: number) => Promise<void>;
}

const generateTimes = (): SelectListItem[] => {
    const items: SelectListItem[] = [];
    for (let hour = 0; hour < 24; hour++) {
        for (let minute = 0; minute < 60; minute += 30) {
            const time = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
            const value = (hour * 60 * 60 * 1000) + (minute * 60 * 1000);
            items.push(TransformProvider.toSelectListItem({ value: value.toString(), text: time }));
        }
    }
    return items;
};

const TimeDropdown: React.FC<TimeDropdownProps> = ({ id, label, disabled, selectedTime, onTimeChange }) => {
    const times = useMemo(generateTimes, []);

    return (
        <Dropdown
            noWrap
            id={id}
            align={DropdownAlign.Left}
            label={label}
            items={times}
            noFilter={true}
            orderBy={DropdownOrderBy.Name}
            requiredType={DropdownRequiredType.Restricted}
            onChange={(_, item: SelectListItem) => onTimeChange(parseInt(item.value))}
            disabled={disabled}
        />
    );
};

export default TimeDropdown;